/**
 * 检查当前代码是否在store中运行
 * @returns 是否在store中
 */
export function checkIsInStore() {
  let isInStore = false;
  try {
    // 存在document则说明不在store中
    isInStore = !document;
  } catch {
    isInStore = true;
  }
  return isInStore;
};
